module.exports = __webpack_public_path__ + "static/media/caret-up-solid.69e7a520.svg";